import { useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import ErrorComponent from "../../../Components/ErrorMessage";
import { replacePlaceholder } from "../../../Utils/Utils";

function StarRatingQuestion({ question, handleChange, formValues, showError }) {
    const isMandatory = question.isMandatory;
    const questionText = replacePlaceholder(question.questionText, formValues);
    
    // Get current rating from formValues
    const currentRating = formValues[question.tempId] || null;
    const hasAnswer = currentRating !== null;

    const handleRatingChange = (value) => {
        handleChange({
            target: { 
                name: question.tempId, 
                value: value,
                type: "rating" 
            },
        });
    };

    const renderStars = () => {
        const stars = [];
        for (let i = 1; i <= question.rateMax; i++) {
            stars.push(
                <Button
                    key={i}
                    variant="light"
                    className="mx-1"
                    onClick={() => handleRatingChange(i)}
                >
                    <i
                        className={`bi bi-star${currentRating >= i ? "-fill" : ""} text-warning`}
                        style={{ fontSize: "1.5rem" }}
                    ></i>
                </Button>
            );
        }
        return stars;
    };

    return (
        <Card className={`my-3 ${isMandatory && showError && !hasAnswer ? "border-danger" : ""}`}>
            <Card.Body>
                <div className="d-flex align-items-center mb-3">
                    <div className="d-flex flex-column">
                        <Form.Label>
                            <b style={{whiteSpace: 'pre-wrap',wordBreak: 'break-word'}}>
                                {question.tempId}.{questionText}
                                {isMandatory && <span className="text-danger">*</span>}
                            </b>
                        </Form.Label>
                        <Form.Label>
                            <b style={{ color: 'lightblue' }}>{question.questionDescription}</b>
                        </Form.Label>
                        {isMandatory && showError && !hasAnswer && (
                            <ErrorComponent message={question.requiredErrorText} />
                        )}
                    </div>
                </div>
                <div className="d-flex align-items-center">
                    {renderStars()}
                    {currentRating && (
                        <span className="ms-3" style={{ fontSize: "1.1rem" }}>
                            {currentRating} {currentRating === 1 ? 'star' : 'stars'}
                        </span>
                    )}
                </div>
            </Card.Body>
        </Card>
    );
}

export default StarRatingQuestion;
